import styled from 'styled-components';

const ContainerGrid = styled.div`
  min-height: 96vh;
  display: grid;
`;

export default ContainerGrid;
